<template>
  <main>
    <slot />
    <Intercom />
    <!-- Newsletter Button -->
    <NewsletterButton />
  </main>
</template>

<script setup lang="ts"></script>
